import { render, staticRenderFns } from "./ModalLockLocation.vue?vue&type=template&id=136a905f"
import script from "./ModalLockLocation.vue?vue&type=script&lang=js"
export * from "./ModalLockLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports